import {lazy} from "react"

export const LogsSystem = lazy(() => import("@/views/logsSystem/LogsSystem"));